var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeoFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 94,
    viewBox: "0 0 110 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3044 2.26601C6.84016 8.75897 2.08517 17.2599 0.426447 27.0908C-0.0711679 30.0634 -0.154104 36.6086 0.288221 39.6596C1.50461 47.9258 5.54082 56.2442 11.2911 62.2939C18.2024 69.5693 26.7447 74.1586 36.9182 76.1144C39.5169 76.6099 40.8162 76.6881 45.9029 76.6621C50.9344 76.6621 52.2614 76.5576 54.6665 76.0883C58.3709 75.3321 62.0478 74.1848 65.1164 72.8027L67.6045 71.6814L76.0087 81.0167C80.9019 86.4146 84.9934 90.7431 85.8228 91.3174C88.2003 92.986 90.6884 93.8203 93.7293 93.9774C98.4843 94.1859 102.023 92.9602 105.175 89.9874C108.16 87.1186 109.487 84.0416 109.487 79.9477C109.487 76.5838 108.437 73.7415 106.336 71.3686C105.783 70.7427 101.387 67.0659 96.5491 63.1805C91.7389 59.3212 87.3709 55.8009 86.8457 55.3836L85.9333 54.6275L87.1774 52.098C93.0105 40.1811 92.8724 26.4649 86.7627 14.9131C85.2145 11.9403 83.4452 9.30668 81.5654 7.06408C79.9342 5.16049 75.0411 0.544987 74.6264 0.544987C74.4605 0.544987 73.8523 1.82272 73.2442 3.41333C72.6635 4.97792 71.5025 7.55952 70.6455 9.15012C69.8162 10.7147 69.125 12.1229 69.125 12.2533C69.125 12.3576 69.7056 13.0616 70.3967 13.8179C74.0736 17.6511 76.8656 23.2053 77.8885 28.7075C78.5244 32.2277 78.2757 38.0428 77.308 41.4849C73.9629 53.2976 63.7065 62.0853 50.7685 64.1975C47.4511 64.7451 41.452 64.5626 38.2452 63.8063C22.4045 60.0774 11.5675 45.7875 13.2262 30.7936C13.9173 24.6135 16.4884 18.7724 20.4692 14.3133C21.2986 13.3746 22.1004 12.4619 22.2385 12.2793C22.4045 12.0707 21.9345 10.8973 20.8286 8.73296C19.8887 6.95979 18.6724 4.29991 18.1194 2.8136C17.5389 1.3533 16.9859 0.153839 16.9031 0.153839C16.8201 0.153839 15.659 1.11858 14.3044 2.26601Z",
    fill: "url(#paint0_linear_1008_874)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1008_874",
    x1: 12.0809,
    y1: 1.37121,
    x2: 88.1911,
    y2: 92.3313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6250FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2D6F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeoFrame);
export default __webpack_public_path__ + "static/media/Seo_frame.f6dc64d9a36a8c1512b54d056bd91963.svg";
export { ForwardRef as ReactComponent };